<template>
  <el-col class="select-js select-primary">
    <!--:item-name="`translations.${locale}`"-->
    <select-primary-js
      v-model="model"
      placeholder=""
      label="name"
      item-name="name"
      group-values="subcategories"
      :group-select="false"
      :searchable="false"
      :multiple="false"
      :options="getOptions"
    >
      <template slot="singleLabel">
        {{ categoryPathLabel }}
      </template>
    </select-primary-js>
  </el-col>
</template>

<script>
  /* eslint-disable no-console */

  import { mapState, mapGetters } from 'vuex';
  import isEqual from 'lodash-es/isEqual';
  import { dataGet } from '@fps/vue-toolkit/dist/util';
  import SelectPrimaryJs from '../MainLeftFilters/SelectPrimaryJs';

  export default {
    components: {
      SelectPrimaryJs,
    },
    computed: {
      model: {
        get() {
          return this.$store.state.filters.subcategory || this.$store.state.filters.category;
        },
        set(value) {
          if (value !== this.category && value !== this.subcategory) {
            // If a subcategory was set set its coresponding category if necessary
            if (value && !value.subcategories) {
              const category = this.categories.find(item => item.id === value.parent_id);
              if (category && !isEqual(category, this.category)) {
                this.$store.dispatch('setCategory', category);
              }
            }

            // Set the current category/subcategory
            this.$store.dispatch(!value || value.subcategories ? 'setCategory' : 'setSubcategory', value);
          }
        },
      },
      categoryPathLabel() {
        const subcategory = dataGet('subcategory.key', this);
        const category = dataGet('category.key', this);

        return `${this.$t(`category.${category}`)}${subcategory ? ` > ${this.$t(`subcategory.${category}.${subcategory}`)}` : ''}`;
      },
      getOptions() {
        return this.categories
          .map(item => ({
            ...item,
            name: this.$t(`category.${item.key}`),
            subcategories: (!item.subcategories || !item.subcategories.length ? [item] : item.subcategories)
              .map(item2 => ({
                ...item2,
                name: item.subcategories && item.subcategories.length ? this.$t(`subcategory.${item.key}.${item2.key}`) : this.$t(`category.${item2.key}`),
              })),
          }));
      },

      ...mapState({
        locale: state => state.locale,
        categories: state => state.temp.categories.list,
        dynamic: state => state.filters.dynamic,
        subcategory: state => state.filters.subcategory,
        category: state => state.filters.category,
      }),
      ...mapGetters([
        'attributeTypes',
      ]),
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainLeftFilters/CategorySelect.vue